import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationService } from '@nk/core/services/navigation.service';
import { NavigationItem } from '@nk/core/services/navigation.utils';

@Component({
  selector: 'nk-header-nav',
  template: `
    <ul class="navbar-nav me-auto header-navbar" *ngIf="navigation$ | async as navigation">
      <li class="nav-item" *ngFor="let navItem of navigation" [attr.data-cy]="'top-navigation-' + navItem.segment">
        <a
          [routerLink]="navItem.url"
          [queryParams]="navItem.url === '' || navItem.url === '/' ? { rbc: true } : {}"
          [class.active]="navItem.active"
          class="nav-link me-2 ms-2">
          <i class="me-1 fa fa-{{ navItem.icon }}"></i>
          {{ navItem.name | translate }}
        </a>
      </li>
    </ul>
  `,
  standalone: false,
})
export class AppHeaderNavComponent implements OnInit {
  public navigation$: Observable<NavigationItem[]>;

  constructor(private _navigationService: NavigationService) {}

  public ngOnInit(): void {
    this.navigation$ = this._navigationService.getNavigation();
  }
}
